const userFullName = (user) => {
  return (user?.first_name || '') + ' ' + (user?.last_name || '')
}

export default userFullName;